module.exports = __webpack_public_path__ + "static/img/0543_1.7dd5c70.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/home/img/0543_1.jpg
// module id = BsXU
// module chunks = 1